module.exports = __webpack_public_path__ + "img/icon_sm_gys.9495227b.png";